/**
 * Represents a swiper functionality for other brokers.
 * This class handles the initialization and configuration of the Swiper.
 */
class OtherBrokers {

	/**
	 * Constructor
	 *
	 * @return {Object} Instance of the class
	 */
	constructor() {

		// eslint-disable-next-line no-console
		console.log( 'test' );
		document.addEventListener( 'DOMContentLoaded', () => {

			this.runSwiper();

		} );

	}

	/**
	 * Show and hide header when site is scrolling
	 *
	 * @return {void}
	 */
	runSwiper() {

		// eslint-disable-next-line no-console
		console.log( 'dziala' );

		/* globals Swiper */
		new Swiper( document.querySelector( '.db-other-brokers__swiper' ), {
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 30,
			loop: 'true',
			speed: 1000,
			autoplay: {
				delay: 3000,
				disableOnInteraction: true,
			},
			breakpoints: {
				760: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 4,
				},

			},
		} );

	}

}
new OtherBrokers();